

import React, { useEffect, useState } from 'react';
import { Table, Button, Popconfirm, Space, Row, Col, Input, Select } from 'antd';
import AppLayout from '../../components/AppLayout';

const RecruitmentList: React.FC = () => {
  const [applications, setApplications] = useState<any[]>([]);
  const [filters, setFilters] = useState({ candidate: '', role: '', status: '' });
  const [filteredApplications, setFilteredApplications] = useState<any[]>([]);

  useEffect(() => {
    const demoData = Array.from({ length: 50 }, (_, i) => ({
      id: i + 1,
      candidate_name: `Candidate ${i + 1}`,
      role: ['Frontend Developer', 'Backend Developer', 'QA Engineer', 'Product Manager'][i % 4],
      status: ['Interview Scheduled', 'Shortlisted', 'Rejected', 'Hired'][i % 4],
    }));
    setApplications(demoData);
    setFilteredApplications(demoData);
  }, []);

  const handleFilterChange = (field: string, value: string) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    const filtered = applications.filter(app =>
      (newFilters.candidate === '' || app.candidate_name.toLowerCase().includes(newFilters.candidate.toLowerCase())) &&
      (newFilters.role === '' || app.role === newFilters.role) &&
      (newFilters.status === '' || app.status === newFilters.status)
    );
    setFilteredApplications(filtered);
  };

  const columns = [
    { title: 'Candidate Name', dataIndex: 'candidate_name', key: 'candidate_name' },
    { title: 'Role', dataIndex: 'role', key: 'role' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_:any, record:any) => (
        <Space>
          <Button type="link">Edit</Button>
          <Popconfirm title="Are you sure to delete?" onConfirm={() => console.log('Delete', record.id)}>
            <Button danger type="link">Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <AppLayout>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8}>
          <Input
            placeholder="Search Candidate"
            value={filters.candidate}
            onChange={(e) => handleFilterChange('candidate', e.target.value)}
          />
        </Col>
        <Col span={8}>
          <Select
            placeholder="Filter by Role"
            value={filters.role}
            onChange={(value) => handleFilterChange('role', value)}
            allowClear
            style={{ width: '100%' }}
          >
            <Select.Option value="Frontend Developer">Frontend Developer</Select.Option>
            <Select.Option value="Backend Developer">Backend Developer</Select.Option>
            <Select.Option value="QA Engineer">QA Engineer</Select.Option>
            <Select.Option value="Product Manager">Product Manager</Select.Option>
          </Select>
        </Col>
        <Col span={8}>
          <Select
            placeholder="Filter by Status"
            value={filters.status}
            onChange={(value) => handleFilterChange('status', value)}
            allowClear
            style={{ width: '100%' }}
          >
            <Select.Option value="Interview Scheduled">Interview Scheduled</Select.Option>
            <Select.Option value="Shortlisted">Shortlisted</Select.Option>
            <Select.Option value="Rejected">Rejected</Select.Option>
            <Select.Option value="Hired">Hired</Select.Option>
          </Select>
        </Col>
      </Row>
      <Table
        dataSource={filteredApplications}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 10 }}
      />
    </AppLayout>
  );
};

export default RecruitmentList;